'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeEquipmentStates = require('./KayleeEquipmentStates');
var KayleeEquipmentStorage = require('./KayleeEquipmentStorage');
var KayleeEquipmentTypes = require('./KayleeEquipmentTypes');
var KayleeEvent = require('./KayleeEvent');
var KayleeEvents = require('./KayleeEvents');
var KayleeUtil = require('./KayleeUtil');
var log = require('../log/Log').channel('KayleeEquipment');
var sutl = require('../sutl/Sutl');

var KayleeEquipment = {
    addUpdatesToCreateEquipment: addUpdatesToCreateEquipment,
    addUpdatesToRemoveEquipment: addUpdatesToRemoveEquipment,
    fromJson: fromJson,
    getDriverId: getDriverId,
    getEquipment: getEquipment,
    getEqTypeConfigProp: getEqTypeConfigProp,
    getEqTypeProp: getEqTypeProp,
};

function addUpdatesToCreateEquipment(update, companyId, siteId, roomId,
    equipmentId, typeId, modelNumberId, ipAddress, username, password, simulate,
    config) {
    update['equipment/' + equipmentId] = {
        companyId: companyId,
        siteId: siteId,
        roomId: roomId,
        type: typeId,
        ipAddress: ipAddress,
    };

    if (typeof modelNumberId !== 'undefined' && modelNumberId !== null) {
        update['equipment/' + equipmentId].modelNumber = modelNumberId;
    }

    if (typeof username !== 'undefined' && username !== null && username !== '') {
        update['equipment/' + equipmentId].username = username;
    }

    if (typeof password !== 'undefined' && password !== null && password !== '') {
        update['equipment/' + equipmentId].password = password;
    }

    if (typeof simulate !== 'undefined' && simulate !== null && simulate === true) {
        update['equipment/' + equipmentId].simulate = simulate;
    }

    if (typeof config !== 'undefined' && config !== null) {
        update['equipment/' + equipmentId].config = config;
    }

    update['index/equipmentByRoom/' + roomId + '/' + equipmentId] = true;

    return KayleeEvent.addUpdatesForEquipmentCreatedEvent(update, roomId,
        equipmentId, typeId, modelNumberId, ipAddress);
}

function addUpdatesToRemoveEquipment(update, roomId, equipmentId, parentEventId) {
    update['equipment/' + equipmentId] = null;
    update['equipmentStates/' + equipmentId] = null;
    update['equipmentStorage/' + equipmentId] = null;
    update['index/equipmentByRoom/' + roomId + '/' + equipmentId] = null;

    return KayleeUtil.loadRoomData({ roomId: roomId })
    .then(function(obj) {
        var calendarSource = sutl.getNode(obj,
            [ 'room', 'settings', 'calendarSource'], null);

        if (calendarSource !== null &&
            calendarSource.type === 'equipment' &&
            calendarSource.id === equipmentId) {
            update['rooms/' + roomId + '/settings/calendarSource'] = null;
        }

        return Promise.resolve();
    })
    .then(function() {
        return KayleeUtil.loadRoomConfigData({ roomId: roomId }, false);
    })
    .then(function(obj) {
        var roomConfig = sutl.getNode(obj, [ 'roomConfig' ], null);
        if (roomConfig === null) return Promise.resolve();
        var key, cfg;
        var removeRoomConfig = update['roomConfig/' + roomId] === null;
        var removeRoomConfigValidated = update['roomConfigValidated/' + roomId] === null;

        if (roomConfig.hasOwnProperty('shadeControls')) {
            for (key in roomConfig.shadeControls) {
                if (!roomConfig.shadeControls.hasOwnProperty(key)) continue;
                cfg = roomConfig.shadeControls[key];

                if (cfg.type === 'emittedAction') {
                    var ccUpdates = {};
                    var isEmpty = true;
                    var motion;
                    var motionCfg;
                    var actionKey;
                    var emittedAction;

                    if ('position' in cfg) {
                        for (motion in cfg.position) { // close, open, stop
                            if (!cfg.position.hasOwnProperty(motion)) continue;
                            motionCfg = sutl.getNode(cfg, ['position', motion, 'actions']);
                            if (!motionCfg) continue;

                            for (actionKey in motionCfg) { // key for each CC config
                                if (!motionCfg.hasOwnProperty(actionKey)) continue;
                                emittedAction = motionCfg[actionKey];
                                if (emittedAction.equipmentId === equipmentId) {
                                    if (!removeRoomConfig) {
                                        ccUpdates['roomConfig/' + roomId + '/shadeControls/' + key +
                                            '/position/' + motion + '/actions/' + actionKey] = null;
                                    }
                                    if (!removeRoomConfigValidated) {
                                        ccUpdates['roomConfigValidated/' + roomId + 
                                            '/shadeControls/' + key + '/position/' + motion + 
                                            '/actions/' + actionKey] = null;
                                    }
                                } else {
                                    isEmpty = false;
                                }
                            }
                        }
                    }

                    if ('tilt' in cfg) {
                        for (motion in cfg.tilt) { // decrease, increase, stop
                            if (!cfg.tilt.hasOwnProperty(motion)) continue;
                            motionCfg = sutl.getNode(cfg, ['tilt', motion, 'actions']);
                            if (!motionCfg) continue;

                            for (actionKey in motionCfg) { // key for each CC config
                                if (!motionCfg.hasOwnProperty(actionKey)) continue;
                                emittedAction = motionCfg[actionKey];
                                if (emittedAction.equipmentId === equipmentId) {
                                    if (!removeRoomConfig) {
                                        ccUpdates['roomConfig/' + roomId + '/shadeControls/' + key +
                                            '/tilt/' + motion + '/actions/' + actionKey] = null;
                                    }
                                    if (!removeRoomConfigValidated) {
                                        ccUpdates['roomConfigValidated/' + roomId + 
                                            '/shadeControls/' + key + '/tilt/' + motion + 
                                            '/actions/' + actionKey] = null;
                                    }
                                } else {
                                    isEmpty = false;
                                }
                            }
                        }
                    }

                    if (isEmpty) {
                        if (!removeRoomConfig) {
                            update['roomConfig/' + roomId + '/shadeControls/' + key] = null;
                        }
                        if (!removeRoomConfigValidated) {
                            update['roomConfigValidated/' + roomId + '/shadeControls/' + key] = null;
                        }
                    } else {
                        for (var path in ccUpdates) {
                            if (!ccUpdates.hasOwnProperty(path)) continue;
                            update[path] = ccUpdates[path];
                        }
                    }
                } else if (cfg.equipmentId === equipmentId) {
                    if (!removeRoomConfig) {
                        update['roomConfig/' + roomId + '/shadeControls/' + key] = null;
                    }
                    if (!removeRoomConfigValidated) {
                        update['roomConfigValidated/' + roomId + '/shadeControls/' + key] = null;
                    }
                }
            }

            for (key in roomConfig.shadePresets) {
                if (!roomConfig.shadePresets.hasOwnProperty(key)) continue;
                cfg = roomConfig.shadePresets[key];
                if (cfg.equipmentId === equipmentId) {
                    if (!removeRoomConfig) {
                        update['roomConfig/' + roomId + '/shadePresets/' + key] = null;
                    }
                    if (!removeRoomConfigValidated) {
                        update['roomConfigValidated/' + roomId + '/shadePresets/' + key] = null;
                    }
                }
            }
        }
    })
    .then(function() {
        return getEquipment(equipmentId).$loaded();
    })
    .then(function(eq) {
        var channelFavorites = sutl.getNode(eq, 'config.channelFavorites', {});
        var imageDeletePromises = [];

        for (var key in channelFavorites) {
            if (!channelFavorites.hasOwnProperty(key)) continue;

            var storageRef = getChannelFavoriteImageStorage(eq, key);

            if (storageRef !== null) {
                imageDeletePromises.push(
                    /*jshint loopfunc: true */
                    storageRef.delete().catch(function(err) {
                        var message = err.message ? err.message : err.toString();
                        log.error('failed deleting channel favorite image: ' + message);
                    })
                );
            }
        }

        return Promise.all(imageDeletePromises);
    })
    .then(function() {
        return KayleeEvent.addUpdatesForEquipmentDeletedEvent(update,
            equipmentId, parentEventId);
    });
}

function fromJson(data) {
    var reqProps = [ '$id' ];
    return FirebaseObject.$fromJson(data, 'Equipment', reqProps, reqProps,
        function(data) { return getEquipment(data.$id); }
    );
}

function getChannelFavoriteImageStorage(eq, favoriteId) {
    var storageInfo = sutl.getNode(eq, ['config', 'channelFavorites', favoriteId, 'image']);

    if (storageInfo === null) return null;
    if (storageInfo.type !== 'storage' ||
        storageInfo.storageType !== 'firebaseStorage' ||
        typeof storageInfo.path !== 'string') {
        log.error('invalid storage info: ' + JSON.stringify(storageInfo));
        return null;
    }

    return KayleeBase.app.storage().ref(storageInfo.path);
}

// getDriverId(eqTypeId: string, modelNumberId: string | undefined): string | undefined;

function getDriverId(eqTypeId, modelNumberId) {
    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();

    if (!eqTypes.$isLoaded()) return undefined;

    var eqType = eqTypes.$recordAt(eqTypeId);

    if (!eqType) return undefined;

    // Most drivers are referenced by the equipment type key. Some drivers have different
    // implementations for different model numbers. Their equipment type keys are all the same, and
    // the equipment type definition contains driver keys based on model number and/or model family.
    // The explicit driverIds can also be used to support multiple equipment type keys that map to
    // the same driver.

    var driverId;

    if (modelNumberId) {
        if (eqType.driverIds && typeof eqType.driverIds !== 'string') {
            driverId = eqType.driverIds[modelNumberId];

            if (!driverId) {
                const familyId = getEqTypeFamilyId(eqTypeId, modelNumberId);
                if (familyId) driverId = eqType.driverIds[familyId];
            }
        } else if (typeof eqType.driverIds === 'string') {
            driverId = eqType.driverIds;
        }
    } else if (typeof eqType.driverIds === 'string') {
        driverId = eqType.driverIds;
    }

    if (!driverId) driverId = eqType.$id;

    return driverId;
};

function getEqTypeFamilyId(eqTypeId, modelNumberId) {
    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();

    if (!eqTypes.$isLoaded()) return null;

    var eqType = eqTypes.$recordAt(eqTypeId);

    if (eqType === null) return;

    var foundFamilyId = null;

    for (var familyId in eqType.modelFamilies) {
        if (!eqType.modelFamilies.hasOwnProperty(familyId)) continue;

        var family = eqType.modelFamilies[familyId];

        for (var i = 0; i < family.modelNumbers.length; i++) {
            if (family.modelNumbers[i] === modelNumberId) {
                foundFamilyId = familyId;
                break;
            }
        }

        if (foundFamilyId !== null) break;
    }

    return foundFamilyId;
}

function getEqTypeConfigProp(eqTypeId, modelNumberId, name) {
    var value;

    if (Array.isArray(name)) {
        value = getEqTypeProp(eqTypeId, modelNumberId, ['config'].concat(name));
    } else {
        value = getEqTypeProp(eqTypeId, modelNumberId, 'config.' + name);
    }

    return value;
}

function getEqTypeProp(eqTypeId, modelNumberId, name) {
    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();

    if (!eqTypes.$isLoaded()) return null;

    var eqType = eqTypes.$recordAt(eqTypeId);

    if (eqType === null) return;

    var value = sutl.getNode(eqType, name);

    if (value === null) return null;

    if (modelNumberId !== null && value.hasOwnProperty(modelNumberId)) {
        return value[modelNumberId];
    }

    var familyId = getEqTypeFamilyId(eqTypeId, modelNumberId);

    if (familyId !== null && value.hasOwnProperty(familyId)) {
        return value[familyId];
    }

    var key = Object.keys(value)[0];

    if (sutl.getNode(eqType, [ 'modelNumbers', key ]) !== null ||
        sutl.getNode(eqType, [ 'modelFamilies', key ]) !== null) {
        return null;
    }

    return value;
}

// Returns a promise that resolves to the Equipment object when it is loaded.

function getEquipment(equipmentId) {
    var key = 'Equipment: ' + equipmentId;
    var equipment = KayleeCache.get(key);

    if (equipment === null) {
        equipment = new Equipment(equipmentId);
        KayleeCache.put(key, equipment);
    }

    return equipment;
}

function Equipment(equipmentId) {
    this.$nodeType = 'equipment';
    KayleeEquipmentTypes.getEquipmentTypes();
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('equipment/' + equipmentId));

}

Equipment.prototype = Object.create(FirebaseObject.prototype);
Equipment.prototype.constructor = Equipment;

Equipment.prototype.$defaults = {
    simulate: false,
    firmwareVersion: '',
    connectState: 'connectFailed',
};

Equipment.prototype.$includeInChangedEvent = {
    config: {
        airPlayContentEnaboed: true,
        alfatronControlChannels: {
            manual: true,
        },
        atdm0604ControlChannels: {
            manual: true,
        },
        audioDialingEnabled: true,
        autoSwitchVideoInputs: true,
        callParticipantsLimit: true,
        cameraPresets: true,
        cameraTrackingUiEnabled: true,
        controlSpaceControlChannels: {
            manual: true,
        },
        convergeProControlChannels: {
            manual: true,
        },
        convergePro2ControlChannels: {
            manual: true,
        },
        deviceId: true,
        displayBlankIndex: true,
        displayBlankUiEnabled: true,
        displayFreezeIndex: true,
        displayFreezeUiEnabled: true,
        displayMotion: true,
        displayVolumeUiEnabled: true,
        dm8000ControlChannels: {
            manual: true,
        },
        extronVolumeControlControlChannels: {
            manual: true,
        },
        initialSpotlight: true,
        ir: true,
        isPowerToggle: true,
        lencoreControlChannels: {
            manual: true,
        },
        lightingControls: true,
        lightingPresets: true,
        macAddress: true,
        mediaOperations: true,
        name: true,
        nexiaControlChannels: {
            manual: true,
        },
        p300ControlChannels: {
            manual: true,
        },
        port: true,
        presenceEnabled: true,
        qSysControlChannels: {
            manual: true,
        },
        radiusControlChannels: {
            manual: true,
        },
        soundStructureControlChannels: {
            manual: true,
        },
        stewartAudioControlChannels: {
            manual: true,
        },
        synchronizedCalls: true,
        tesiraControlChannels: {
            manual: true,
        },
        useCalendar: true,
        useDirectory: true,
        videoInputs: true,
        viscaControlChannels: {
            cameras: {
                manual: true,
            },
        },
        zoomConnectorEnabled: true,
        zoomControlChannels: {
            manual: true,
        },
    },
    finalConnectState: true,
    firmwareVersion: true,
    ipAddress: true,
    modelNumber: true,
    serialNumber: true,
    username: true,
    password: true,
    simulate: true,
    type: true,
};

Equipment.prototype.$addUpdatesForChangedEvent =
    KayleeEvent.addUpdatesForEquipmentChangedEvent;

// This function reports whether or not a videoInput and videoOutput are compatible when routing
// a video signal directly from one piece of equipment to another. This is not meant for reporting
// whether or not videoInput is routable to a video output on the same piece of equipment.
// Currently, that test is always true. If we need to add that test in the future, we will likely
// add an areInternalVideoSignalsCompatible function along with an internalSignalType property on
// the video inputs and outputs.

Equipment.prototype.$areVideoSignalsCompatible = function(videoInput, videoOutput) {
    var videoInputSignalType = videoInput.signalType === undefined ? 'physical' : videoInput.signalType;
    var videoOutputSignalType = videoOutput.signalType === undefined ? 'physical' : videoOutput.signalType;
    return (
        videoInputSignalType === 'any' ||
        videoOutputSignalType === 'any' ||
        videoInputSignalType === videoOutputSignalType
    );
};

Equipment.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$id' ]);
};

Equipment.prototype.toString = function() {
    if (!this.$internalIsLoaded) {
        return 'Equipment (' + this.$id + ')]';
    }

    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();
    var eqStr;

    if (eqTypes.$internalIsLoaded) {
        var eqType = eqTypes.$recordAt(this.type);
        eqStr = eqType.manufacturer + ' ' + eqType.model + ' at ' + this.ipAddress;
    } else {
        eqStr = '(' + this.type + ')';
    }


    return '[Equipment ' + eqStr + ' (' + this.$id + ')]';
};

Equipment.prototype.$createNewChannelFavoriteImageStorage = function() {
    var key = sutl.generateFirebaseId();
    var path = 'equipment/' + this.$id + '/channelFavoriteImages/' + key + '/image';
    return KayleeBase.app.storage().ref(path);
};

Equipment.prototype.$deleteChannelFavoriteImageStorage = function(favoriteId) {
    var self = this;
    return Promise.resolve()
    .then(function() {
        var currentStorageRef = self.$getChannelFavoriteImageStorage(favoriteId);

        if (currentStorageRef !== null) {
            return currentStorageRef.delete();
        }
    })
    .then(function() {
        sutl.deleteNode(self, ['config', 'channelFavorites', favoriteId, 'image']);
    });
};

Equipment.prototype.$getChannelFavoriteImageStorage = function(favoriteId) {
    return getChannelFavoriteImageStorage(this, favoriteId);
};

Equipment.prototype.$getManufacturer = function() {
    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();

    if (eqTypes.$isLoaded()) return eqTypes.$recordAt(this.type).manufacturer;
    return 'Unknown';
};

Equipment.prototype.$getModel = function() {
    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();

    if (eqTypes.$isLoaded()) return eqTypes.$recordAt(this.type).model;
    return 'Unknown';
};

Equipment.prototype.$getModelNumber = function() {
    if (typeof this.modelNumber === 'undefined') return null;

    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();

    if (eqTypes.$isLoaded()) return eqTypes.$recordAt(this.type).modelNumbers[this.modelNumber];
    return 'Unknown';
};

Equipment.prototype.$getStates = function() {
    return KayleeEquipmentStates.getEquipmentStates(this.$id);
};

Equipment.prototype.$getStorage = function() {
    return KayleeEquipmentStorage.getEquipmentStorage(this.$id);
};

Equipment.prototype.$getType = function() {
    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();

    if (eqTypes.$isLoaded()) return eqTypes.$recordAt(this.type).type;
    return 'Unknown';
};

Equipment.prototype.$remove = function() {
    if (!this.$internalIsLoaded) {
        var err = new Error(this + ' not loaded');
        log.error(err.message);
        return Promise.reject(err);
    }

    var self = this;

    return addUpdatesToRemoveEquipment({}, self.roomId, self.$id)
    .then(function(update) {
        KayleeBase.update(update)
        .then(function() {
            log.info('removed ' + self);
        }, function(err) {
            log.error('failed removing ' + self + ', error: ' + err);
        });
    });
};

Equipment.prototype.$getEvents = function(limit) {
    return KayleeEvents.getEvents(this, limit);
};

Equipment.prototype.$getFamilyId = function(eqType, selectedModelNumber) {
    var foundFamilyId = null;

    for (var familyId in eqType.modelFamilies) {
        if (!eqType.modelFamilies.hasOwnProperty(familyId)) continue;

        var family = eqType.modelFamilies[familyId];

        for (var i = 0; i < family.modelNumbers.length; i++) {
            if (family.modelNumbers[i] === 
                    (typeof selectedModelNumber === 'undefined' ?
                        this.modelNumber :
                        selectedModelNumber)) {
                foundFamilyId = familyId;
                break;
            }
        }

        if (foundFamilyId !== null) break;
    }

    return foundFamilyId;
};

Equipment.prototype.$getAvailableVideoInputs = function(selectedModelNumber) {
    // First, if the user has not selected a model number to change to, see if 
    // there are detected video inputs. Note that this is fragile since it 
    // depends on the equipment states being $loaded.
    // Otherwise, if they have selected a model number, check if this model
    // has detected inputs and return null, since we need to reconnect with
    // the new model number to get the detected channels.

    var states = this.$getStates();
    var detectedVideoInputs = null;
    if (typeof selectedModelNumber === 'undefined') {
        detectedVideoInputs = sutl.getNode(states, 'detected.videoInputs');
        if (detectedVideoInputs !== null) return detectedVideoInputs;
    } else if (getEqTypeConfigProp(
        this.type, selectedModelNumber, 'hasDetectedVideoInputs') === true) {
        return null;
    }

    // Next, see if they're available in the user driver config.

    detectedVideoInputs =
        sutl.getNode(this, 'config.userDriver.controls.videoMatrixRoutes.videoInputs');
    if (detectedVideoInputs !== null) return detectedVideoInputs;

    detectedVideoInputs =
        sutl.getNode(this, 'config.userDriver.controls.videoInput.videoInputs');
    if (detectedVideoInputs !== null) return detectedVideoInputs;

    // Otherwise, get them from the equipment type definition. Note that this is also fragile since
    // it depends on the equipment types being $loaded.

    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();

    if (!eqTypes.$isLoaded()) return null;

    var eqType = eqTypes.$recordAt(this.type);
    var availableInputs = sutl.getNode(eqType, 'config.videoInputs.availableInputs');
    if (availableInputs === null) return null;

    // For Zoom, augment video inputs with detected cameras so they can be used as content sources
    // (SNTY-2170). Note that this is fragile since it depends on equipment states being $loaded.

    var cameraInputs = {};

    if (this.type === '-LDmH6a8aVJTYIXyiiQ9') {
        var detectedChannels = sutl.getNode(states, 'detected.channels');

        for (var id in detectedChannels) {
            if (!detectedChannels.hasOwnProperty(id)) continue;
            var channel = detectedChannels[id];

            if (channel.type === 'usbCamera' &&
                !sutl.getNode(channel, 'filters.videoInput', false)) {
                cameraInputs[sutl.generateFirebaseId()] = {
                    code: 'camera.' + channel.zoomId,
                    name: channel.name,
                    external: false,
                    farContent: true,
                    icon: 'camera',
                };
            }
        }
    }

    // If the user has selected a model number to change to, use that as the
    // key to the available inputs, otherwise use the current model number.

    var modelNumber = typeof selectedModelNumber === 'undefined' ?
        this.modelNumber : selectedModelNumber;

    if (availableInputs.hasOwnProperty(modelNumber)) {
        return Object.assign(cameraInputs, availableInputs[modelNumber]);
    }

    var familyId = this.$getFamilyId(eqType, modelNumber);

    if (familyId === null) return Object.assign(cameraInputs, availableInputs);

    if (!availableInputs.hasOwnProperty(familyId)) return null;

    return Object.assign(cameraInputs, availableInputs[familyId]);
};

Equipment.prototype.$getEqTypeConfigProp = function(name) {
    return getEqTypeConfigProp(this.type, this.modelNumber, name);
};

Equipment.prototype.$getEqTypeProp = function(name) {
    return getEqTypeProp(this.type, this.modelNumber, name);
};

Equipment.prototype.$getVideoOutputs = function(includeDetected) {
    if (typeof includeDetected === 'undefined') includeDetected = true;

    // First, see if there are detected video outputs. Note that this is fragile since it depends
    // on the equipment states being $loaded.

    if (includeDetected) {
        var states = this.$getStates();
        var detectedVideoOutputs = sutl.getNode(states, 'detected.videoOutputs');
        if (detectedVideoOutputs !== null) return detectedVideoOutputs;
    }

    // Next, see if they're in the user driver config.

    var availableOutputs =
        sutl.getNode(this, 'config.userDriver.controls.videoMatrixRoutes.videoOutputs');
    if (availableOutputs !== null) return availableOutputs;

    // Otherwise, get them from the equipment type definition. Note that this is also fragile since
    // it depends on the equipment types being $loaded.

    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();

    if (!eqTypes.$isLoaded()) return null;

    var eqType = eqTypes.$recordAt(this.type);
    availableOutputs = sutl.getNode(eqType, 'config.videoOutputs.availableOutputs');
    if (availableOutputs === null) return null;

    if (availableOutputs.hasOwnProperty(this.modelNumber)) {
        return availableOutputs[this.modelNumber];
    }

    var familyId = this.$getFamilyId(eqType);

    if (familyId === null) return availableOutputs;

    if (!availableOutputs.hasOwnProperty(familyId)) return null;

    return availableOutputs[familyId];
};

Equipment.prototype.$hasEqTypeConfigProp = function(name) {
    var eqTypes = KayleeEquipmentTypes.getEquipmentTypes();

    if (!eqTypes.$isLoaded()) return false;

    var eqType = eqTypes.$recordAt(this.type);

    if (eqType === null ||
        !eqType.hasOwnProperty('config') ||
        !eqType.config.hasOwnProperty(name)) {
        return false;
    }

    if (typeof eqType.config[name] === 'boolean') {
        return eqType.config[name];
    }

    if (eqType.config[name].hasOwnProperty(this.modelNumber)) {
        return eqType.config[name][this.modelNumber];
    }

    var familyId = this.$getFamilyId(eqType);

    if (familyId !== null && eqType.config[name].hasOwnProperty(familyId)) {
        return eqType.config[name][familyId];
    }

    return false;
};

Equipment.prototype.$hasVideoSwitcher = function() {
    return this.$hasEqTypeConfigProp('hasVideoSwitcher');
};

Equipment.prototype.$hasCalendar = function() {
    return this.$hasEqTypeConfigProp('hasCalendar');
};

Equipment.prototype.$hasDirectory = function() {
    return this.$hasEqTypeConfigProp('hasDirectory');
};

Equipment.prototype.$setChannelFavoriteImageStorage = function(favoriteId, storageRef) {
    var self = this;
    return Promise.resolve()
    .then(function() {
        var currentStorageRef = self.$getChannelFavoriteImageStorage(favoriteId);

        if (currentStorageRef !== null && currentStorageRef.fullPath !== storageRef.fullPath) {
            return currentStorageRef.delete()
            .catch(function(error) {
                log.error(error.message);
            });
        }
    })
    .finally(function() {
        sutl.setNode(self, ['config', 'channelFavorites', favoriteId, 'image'], {
            type: 'storage',
            storageType: 'firebaseStorage',
            path: storageRef.fullPath,
        });
    });
};

Equipment.prototype.$setDetectedState = function(value) {
    // Note: we assume equipment states have been $loaded().
    var equipmentStates = KayleeEquipmentStates.getEquipmentStates(this.$id);
    var values = equipmentStates.$getValues();
    values.detected = value;
    // Note: we don't return the $set() promise because it can hang under some conditions when we
    // are offline.
    equipmentStates.$set(values);
    return Promise.resolve();
};

Equipment.prototype.$setEquipmentInfoState = function(value) {
    // Note: we assume equipment states have been $loaded().
    var equipmentStates = KayleeEquipmentStates.getEquipmentStates(this.$id);
    var values = equipmentStates.$getValues();
    values.equipmentInfo = value;
    // Note: we don't return the $set() promise because it can hang under some conditions when we
    // are offline.
    equipmentStates.$set(values);
    return Promise.resolve();
};

Equipment.prototype.$setStorage = function(value) {
    // Note: we assume equipment storage has been $loaded().
    var equipmentStorage = KayleeEquipmentStorage.getEquipmentStorage(this.$id);
    equipmentStorage.$set(value);
    // Note: we don't return the $set() promise because it can hang under some conditions when we
    // are offline.
    return Promise.resolve();
};

Equipment.prototype.$setValidatedState = function(value, opts) {
    // Note: we assume equipment states have been $loaded().
    var equipmentStates = KayleeEquipmentStates.getEquipmentStates(this.$id);
    var values = equipmentStates.$getValues();
    values.validated = value;
    // Note: we don't return the $set() promise because it can hang under some conditions when we
    // are offline.

    if (sutl.getNode(opts, ['ignoreError'])) {
        equipmentStates.$set(values).catch(function(error) {});
    } else {
        equipmentStates.$set(values);
    }
    return Promise.resolve();
};

module.exports = KayleeEquipment;
